<template>
  <div class="add-drug-container">
    <el-dialog :title="nameTitle" :visible.sync="dialogVisible" width="80%" top="5vh" v-loading="loading"
      class="add-drug-dialog" @close="handleClose"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :append-to-body="false"
      :show-close="false">

      <template slot="title">
        <div class="dialog-header">
          <span class="dialog-header-title">{{ nameTitle }}</span>
          <div class="header-buttons">
            <el-button type="text" @click="dialogVisible = false" icon="el-icon-close" class="close-button"></el-button>
          </div>
        </div>
      </template>

      <div class="dialog-content">
        <div class="top-section">
          <div class="form-top">
            <el-form :model="form" ref="topForm" label-width="120px" size="small"
              :rules="formRules" :disabled="formDisabled || mode === 'view'">

              <div class="tab-content-fixed-height">
                <el-tabs v-model="activeTab" class="form-tabs">
                  <el-tab-pane label="基本内容" name="basic">
                    <basic-info ref="basicInfo" :form="form"
                      :form-disabled="formDisabled || mode === 'view'" :mode="mode"
                      :field-config="fieldConfigs.basic" @update="handleFormUpdate"
                      :disable-packing-quantity="disablePackingQuantity">
                    </basic-info>
                  </el-tab-pane>
                  <el-tab-pane label="扩展信息" name="extended">
                    <kz-info ref="kzInfo" :form="form" :form-disabled="formDisabled || mode === 'view'"
                      :mode="mode" :field-config="fieldConfigs.extended" @update="handleFormUpdateF3">
                    </kz-info>
                  </el-tab-pane>
                  <el-tab-pane label="使用注意" name="usage">
                    <use-info ref="useInfo" :form="form" :form-disabled="formDisabled || mode === 'view'"
                      :mode="mode" :field-config="fieldConfigs.usage" @update="handleFormUpdateF4">
                    </use-info>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </el-form>
          </div>
        </div>

        <div class="bottom-section">
          <div class="section-header">
            <div class="section-title">
              <i class="el-icon-price-tag" style="margin-right: 6px; color: #00557f;"></i>
              <span>单位及价格</span>
            </div>
          </div>
          <div class="unit-price-layout">
            <div class="unit-price-table-wrapper">
              <el-table :data="tableRows" border style="width:100%;" size="small" class="unit-table">
                <el-table-column label="基础包装参数" min-width="160">
                  <template slot-scope="scope">
                    <div style="display:flex;align-items:center;gap:6px;">
                      <span style="font-weight:bold;color:#00557f;white-space:nowrap;font-size:12px;min-width:56px;">
                        {{ scope.row.label }}：
                      </span>
                      <el-select 
                        v-if="scope.row.key === 'pack'"
                        v-model="form.packUnitId"
                        placeholder="请选择"
                        filterable
                        clearable
                        :disabled="mode === 'view'"
                        size="mini"
                        style="flex:1;"
                        @change="handleUnitChange">
                        <el-option
                          v-for="item in dosUntOptions"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id">
                        </el-option>
                      </el-select>
                      <el-select 
                        v-else
                        v-model="form.minUnitId"
                        placeholder="请选择"
                        filterable
                        clearable
                        :disabled="mode === 'view'"
                        size="mini"
                        style="flex:1;"
                        @change="handleUnitChange">
                        <el-option
                          v-for="item in dosUntOptions"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="单位换算率" min-width="100">
                  <template slot-scope="scope">
                    <el-input 
                      v-if="scope.row.key === 'pack'"
                      v-model.number="form.packConversionRate"
                      placeholder="换算率"
                      :disabled="mode === 'view'"
                      size="mini"
                      clearable
                      @input="handleRateInput">
                    </el-input>
                    <el-input 
                      v-else
                      v-model.number="form.minConversionRate"
                      placeholder="换算率"
                      :disabled="true"
                      size="mini"
                      clearable>
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column label="零售价" min-width="100">
                  <template slot-scope="scope">
                    <el-input 
                      v-if="scope.row.key === 'pack'"
                      v-model="form.packRetailPrice"
                      placeholder="零售价"
                      :disabled="mode === 'view'"
                      size="mini"
                      clearable
                      @input="clearPackRetailError"
                      :class="{'retail-error': retailErrors.pack}"
                    >
                    </el-input>
                    <el-input 
                      v-else
                      v-model="form.minRetailPrice"
                      placeholder="零售价"
                      :disabled="mode === 'view'"
                      size="mini"
                      clearable
                      @input="clearMinRetailError"
                      :class="{'retail-error': retailErrors.min}"
                    >
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column label="会员价" min-width="100">
                  <template slot-scope="scope">
                    <el-input 
                      v-if="scope.row.key === 'pack'"
                      v-model="form.packMemberPrice"
                      placeholder="会员价"
                      :disabled="mode === 'view'"
                      size="mini"
                      clearable>
                    </el-input>
                    <el-input 
                      v-else
                      v-model="form.minMemberPrice"
                      placeholder="会员价"
                      :disabled="mode === 'view'"
                      size="mini"
                      clearable>
                    </el-input>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="unit-relation-right">
              <span class="relation-label">单位关系：</span>
              <span class="relation-value" v-if="relationText">{{ relationText }}</span>
              <span class="relation-placeholder" v-else>（无换算关系）</span>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer" v-if="mode !== 'view'">
        <el-button size="mini" type="primary" @click="submitForm">
          {{ mode === 'edit' ? '修改保存' : '确认添加' }}
        </el-button>
        <el-button size="mini" @click="dialogVisible = false">关闭</el-button>
      </div>
      <div slot="footer" class="dialog-footer" v-else>
        <el-button size="mini" @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BasicInfo from './F2.vue';
import kzInfo from './F3.vue';
import useInfo from './F4.vue';
import { pinyin } from 'pinyin-pro';
import { FieldList } from "@/api/Outpatient/field.js";
import { getDInfo, getDInfos, getDosageForm, getDrugUnt } from "@/api/MedicenCata.js";
import { addDrugInformation, updateDrugInformation } from "@/api/MedicenCata.js";
import { dict } from "@/api/staff/staff.js";

const elSelectInfiniteScroll = {
  bind(el, binding) {
    const SELECTWRAPPER_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
    if (SELECTWRAPPER_DOM) {
      SELECTWRAPPER_DOM.addEventListener('scroll', function() {
        const condition = this.scrollHeight - this.scrollTop - 1 <= this.clientHeight;
        if (condition) {
          binding.value();
        }
      });
    }
  }
};

export default {
  name: 'AddDrugDialog',
  components: { BasicInfo, kzInfo, useInfo },
  directives: { 'el-select-infinite-scroll': elSelectInfiniteScroll },
  data() {
    return {
      dialogVisible: false,
      nameTitle: '',
      mode: 'add',
      loading: false,
      form: {
        state: 1,
        kcId: 0,
        drugCodeId: '',
        dosageForm: '',
        drugType: 1,
        drugName: '',
        drugCodeName: '',
        code: '',
        drugSpec: '',
        dosForm: '',
        pyCode: '',
        mrsId: '',
        expensiveType: 1,
        packUnitId: null,
        packConversionRate: null,
        packRetailPrice: null,
        packMemberPrice: null,
        minUnitId: null,
        minConversionRate: 1,
        minRetailPrice: null,
        minMemberPrice: null,
        manuLotnum: '',
        manufacturer: null,
        manufacturerName: null,
        periodControl: 0,
        warningDays: 0,
        expyDate: null,
        approvalNumber: '',
      },
      formRules: {
        drugCodeId: [{ required: true, message: '请选择药典名称', trigger: 'change' }],
        dosageForm: [{ required: true, message: '请选择药品剂型', trigger: 'change' }]
      },
      NameOptions: [],
      currentQuery: '',
      pageNum: 1,
      pageSize: 48,
      hasMore: true,
      scrollLoading: false,
      showNoDataPrompt: false,
      fieldConfigs: { basic: [], extended: [], usage: [] },
      fieldConfigsLoaded: false,
      currentTabGroup: 'basic',
      dosageFormOptions: [],
      drugTypeOption: [
        { id: 1, label: '西药' },
        { id: 2, label: '成药' },
        { id: 3, label: '卫材' },
        { id: 4, label: '血液' },
        { id: 5, label: '疫苗' }
      ],
      retailErrors: {
        pack: false,
        min: false
      },
      activeTab: 'basic',
      formDisabled: false,
      disablePackingQuantity: false,
      dosUntOptions: [],
      statusMap: { 0: '禁用', 1: '可用' },
      drugTracBMap: { 0: '否', 1: '是' },
      tableRows: [
        { key: 'pack', label: '最小单位' },
        { key: 'min', label: '包装单位' }
      ],
      pendingPreFillData: null,
    };
  },
  computed: {
    relationText() {
      if (this.form.pacSpec && this.form.pacSpec.trim()) {
        return this.form.pacSpec;
      }
      const packUnit = this.dosUntOptions.find(item => item.id === this.form.packUnitId);
      const minUnit = this.dosUntOptions.find(item => item.id === this.form.minUnitId);
      const packRate = parseFloat(this.form.packConversionRate);
      const minRate = parseFloat(this.form.minConversionRate);
      if (packUnit && minUnit && packRate > 0 && minRate > 0) {
        return `${minRate} ${minUnit.label} = ${packRate} ${packUnit.label}`;
      }
      return '';
    }
  },
  watch: {
    'form.kcId': {
      immediate: true,
      handler(newVal) {
        this.disablePackingQuantity = Number(newVal) === 1;
      }
    },
    activeTab(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.fixScrollContainers();
          }, 100);
        });
      }
    },
    'form.packUnitId'(newVal, oldVal) {
      if (newVal && this.form.minUnitId && newVal === this.form.minUnitId) {
        this.form.packConversionRate = 1;
        this.form.minConversionRate = 1;
      }
      if (oldVal !== newVal) {
        this.form.pacSpec = '';
      }
    },
    'form.minUnitId'(newVal, oldVal) {
      if (newVal && this.form.packUnitId && newVal === this.form.packUnitId) {
        this.form.packConversionRate = 1;
        this.form.minConversionRate = 1;
      }
      if (oldVal !== newVal) {
        this.form.pacSpec = '';
      }
    },
  },
  methods: {
    openAddModel(param) {
      this.dialogVisible = true;
      this.nameTitle = param.label || '新增西药目录';
      this.mode = param.mode || 'add';
      // 保存预填数据到局部变量，避免在异步中丢失
      const preFillData = param.preFillData || null;
      this.pendingPreFillData = preFillData;
	  
      if ((this.mode === 'edit' || this.mode === 'view') && param.id) {
        this.loadEditData(param.id);
        return;
      }

      this.resetForm();
      this.loading = true;
      Promise.all([
        this.loadFieldConfigs(),
        this.loadDosUntOptions()
      ]).then(() => {
        // 1. 先处理单位及价格相关的预填（父组件处理）
        if (preFillData) {
          this.applyPreFillData(preFillData);
        }
		// 如果存在预填数据（说明来自追溯码），则设置追溯码开关和效期管理为启用
		if (preFillData && preFillData.drugName) {
		    this.form.isBar = 1;
		    this.form.periodControl = 1;
		}
        // 2. 等待基本内容组件渲染完成，将预填数据传递给它（使用局部变量）
        this.$nextTick(() => {
          if (this.$refs.basicInfo && preFillData) {
            this.$refs.basicInfo.applyPreFillData(preFillData);
          }
          this.ensureFieldConfigPassed();
          setTimeout(() => {
            this.fixScrollContainers();
          }, 300);
        });
        // 清空暂存数据（但局部变量仍有效）
        this.pendingPreFillData = null;
      }).catch(error => {
        console.error('加载数据失败:', error);
        this.$message.error('打开对话框失败');
      }).finally(() => {
        this.loading = false;
      });
    },

    // 父组件处理单位及价格等（不涉及基本字段）
    applyPreFillData(data) {
      if (!data) return;
      // 包装数量 -> 换算率
      if (data.pacCnt && data.pacCnt > 0) {
        this.form.packConversionRate = data.pacCnt;
        this.form.minConversionRate = 1;
      }
      // 批准文号（扩展信息）
      if (data.approvalLicenceNo) {
        this.form.approvalNumber = data.approvalLicenceNo;
        if (this.$refs.kzInfo) {
          this.$refs.kzInfo.setFieldValue && this.$refs.kzInfo.setFieldValue('approvalNumber', data.approvalLicenceNo);
        }
      }
      // 生产批号、生产日期、有效期等可选，暂不处理
    },

    handleUnitChange() {
      this.form.pacSpec = '';
    },
    handleRateInput() {},
    fixScrollContainers() {
      this.$nextTick(() => {
        const tabContents = [
          this.$refs.basicTabContent,
          this.$refs.extendedTabContent,
          this.$refs.usageTabContent
        ];
        tabContents.forEach((container) => {
          if (container) {
            const scrollContainer = container.querySelector('.form-scroll-container');
            if (scrollContainer) {
              const computedHeight = container.clientHeight;
              if (computedHeight > 0) {
                scrollContainer.style.height = `${computedHeight}px`;
              }
              const isOverflowing = scrollContainer.scrollHeight > scrollContainer.clientHeight;
              if (isOverflowing) {
                scrollContainer.style.overflowY = 'scroll';
              }
            }
          }
        });
      });
    },
    forceResetChildValidation() {
      if (this.$refs.basicInfo) {
        this.$refs.basicInfo.validateOnOpen = false;
        if (this.$refs.basicInfo.$refs && this.$refs.basicInfo.$refs.form) {
          this.$nextTick(() => {
            this.$refs.basicInfo.$refs.form.clearValidate();
          });
        }
      }
    },
    ensureFieldConfigPassed() {
      if (!this.fieldConfigsLoaded) return;
      this.updateBasicInfoFieldConfig();
      if (this.mode === 'edit' || this.mode === 'view') {
        this.updateExtendedInfoFieldConfig();
        this.updateUsageInfoFieldConfig();
      }
    },
    updateBasicInfoFieldConfig() {
      if (this.$refs.basicInfo && typeof this.$refs.basicInfo.setFieldConfig === 'function') {
        this.$refs.basicInfo.setFieldConfig(this.fieldConfigs.basic);
      }
    },
    updateExtendedInfoFieldConfig() {
      if (this.$refs.kzInfo && typeof this.$refs.kzInfo.setFieldConfig === 'function') {
        this.$refs.kzInfo.setFieldConfig(this.fieldConfigs.extended);
      }
    },
    updateUsageInfoFieldConfig() {
      if (this.$refs.useInfo && typeof this.$refs.useInfo.setFieldConfig === 'function') {
        this.$refs.useInfo.setFieldConfig(this.fieldConfigs.usage);
      }
    },
    async loadFieldConfigs() {
      try {
        const res = await FieldList({ pageSize: 999, pageNum: 1, typeCode: 1 });
        if (res.code === 200) {
          let fieldList = res.data.content || [];
          fieldList = fieldList.map(field => {
            if (field.moduleName === '基本内容') {
              return { ...field, moduleName: '基础字段' };
            }
            return field;
          });
          await this.processFieldConfigs(fieldList);
          this.fieldConfigsLoaded = true;
        } else {
          this.$message.error(res.message || '字段配置加载失败');
        }
      } catch (error) {
        console.error('加载字段配置失败:', error);
        this.$message.error('字段配置加载失败');
      }
    },
    processFieldConfigs(fieldData) {
      return new Promise((resolve) => {
        this.fieldConfigs = { basic: [], extended: [], usage: [] };
        if (!fieldData || fieldData.length === 0) {
          resolve();
          return;
        }
        fieldData.forEach(field => {
          const moduleCode = field.moduleCode || 1;
          const formattedField = this.formatFieldConfig(field);
          if (formattedField.fieldCode === 'state') {
            formattedField.inputBoxType = 'switch';
            formattedField.options = [
              { value: 0, label: '禁用' },
              { value: 1, label: '可用' }
            ];
          }
          switch (moduleCode) {
            case 2: this.fieldConfigs.basic.push(formattedField); break;
            case 3: this.fieldConfigs.extended.push(formattedField); break;
            case 4: this.fieldConfigs.usage.push(formattedField); break;
            default: console.warn('未知模块代码:', moduleCode, field);
          }
        });
        resolve();
      });
    },
    formatFieldConfig(field) {
      const fieldConfig = {
        fieldCode: field.fieldCode || '',
        fieldName: field.fieldName || '',
        displayName: field.displayName || '',
        isRequired: field.isRequired || false,
        isDisplay: field.isDisplay !== undefined ? field.isDisplay : true,
        isEdit: field.isEdit !== undefined ? field.isEdit : true,
        fieldType: field.fieldType || 'input',
        dataType: field.dataType || 'string',
        fieldLength: field.fieldLength || 0,
        fieldSequence: field.fieldSequence || 0,
        defaultValue: field.defaultValue || '',
        options: field.options || [],
        validationRules: field.validationRules || [],
        helpText: field.helpText || '',
        placeholder: field.placeholder || '',
        ...field
      };
      if (fieldConfig.fieldCode === 'state') {
        fieldConfig.inputBoxType = 'switch';
        fieldConfig.options = [
          { value: 0, label: '禁用' },
          { value: 1, label: '可用' }
        ];
      } else {
        fieldConfig.inputBoxType = field.inputBoxType || 'input';
      }
      return fieldConfig;
    },
    async loadDosUntOptions() {
      try {
        const res = await getDrugUnt();
        if (res.code === 200) {
          this.dosUntOptions = res.data.map(item => ({
            id: item.id,
            label: item.name,
            ...item
          }));
        } else {
          this.$message.error(res.message || '获取剂量单位失败');
        }
      } catch (error) {
        console.error('加载剂量单位失败:', error);
      }
    },
    async loadEditData(id) {
      try {
        this.loading = true;
        let res = await getDInfos({ id: id });
        if (res.code === 200) {
          this.resetForm();
          const kcId = res.data.kcId || 0;
          this.form = {
            ...this.form,
            ...res.data,
            state: String(res.data.state || '1'),
            kcId: kcId
          };
          if (res.data.expensiveType === undefined || res.data.expensiveType === null) {
            this.form.expensiveType = 1;
          }
          this.disablePackingQuantity = Number(kcId) === 1;

          if (res.data.list && res.data.list.length > 0) {
            const firstManufacturer = res.data.list[0];
            this.form.manufacturer = firstManufacturer.prodentpId || null;
            this.form.manuLotnum = firstManufacturer.manuLotnum || '';
            this.form.periodControl = firstManufacturer.periodControl !== undefined ? firstManufacturer.periodControl : 0;
            this.form.expyDate = firstManufacturer.expyDate !== undefined ? firstManufacturer.expyDate : null;
            this.form.warningDays = firstManufacturer.warningDays !== undefined ? firstManufacturer.warningDays : 0;
          }

          await this.handleDrugCodeDisplay(res.data);
          await this.handleDosageFormDisplay(res.data);
          this.handleUnitPriceData(res.data);
        }
      } catch (error) {
        console.error('加载编辑数据失败:', error);
        this.$message.error('加载数据失败');
      } finally {
        this.loading = false;
      }
    },
    handleDrugCodeDisplay(formData) {
      if ((this.mode === 'edit' || this.mode === 'view') && formData.drugCodeName) {
        this.form.drugCodeName = formData.drugCodeName;
        this.form.drugCodeId = formData.drugCodeId;
        if (this.mode === 'edit' && formData.drugCodeName) {
          this.currentQuery = formData.drugCodeName;
          return this.loadCurrentDrugToOptions(formData);
        } else if (this.mode === 'view') {
          this.currentQuery = formData.drugCodeName;
          this.NameOptions = [{
            id: formData.drugCodeId,
            label: formData.drugCodeName,
            drugCode: formData.code || '',
            specifications: formData.drugSpec || '',
            dosageForm: formData.dosformName || '',
            approvalNumber: formData.approvalNumber || '',
            licensorChinese: formData.manufacturerName || '',
            _uid: Math.random().toString(36).substr(2, 9)
          }];
        }
      }
      return Promise.resolve();
    },
    async loadCurrentDrugToOptions(formData) {
      try {
        this.NameOptions = [{
          id: formData.drugCodeId,
          label: formData.drugCodeName,
          drugCode: formData.code || '',
          specifications: formData.drugSpec || '',
          dosageForm: formData.dosformName || '',
          approvalNumber: formData.approvalNumber || '',
          licensorChinese: formData.manufacturerName || '',
          _uid: Math.random().toString(36).substr(2, 9)
        }];
        await this.loadDefaultDrugOptions();
      } catch (error) {
        console.error('加载药典选项失败:', error);
      }
    },
    async loadDefaultDrugOptions() {
      try {
        const res = await getDInfo({ productName: '', pageNum: 1, pageSize: 20 });
        if (res.code === 200 && res.data.content && res.data.content.length > 0) {
          const defaultOptions = res.data.content.map(v => ({
            id: v.id,
            label: v.productName,
            drugCode: v.drugCode || '',
            specifications: v.specifications || '',
            dosageForm: v.dosageForm || '',
            approvalNumber: v.approvalNumber || '',
            licensorChinese: v.licensorChinese || '',
            _uid: Math.random().toString(36).substr(2, 9)
          }));
          const existingIds = this.NameOptions.map(item => item.id);
          const newOptions = defaultOptions.filter(item => !existingIds.includes(item.id));
          this.NameOptions = [...this.NameOptions, ...newOptions];
          this.hasMore = res.data.content.length >= 20;
        }
      } catch (error) {
        console.error('加载默认药典选项失败:', error);
      }
    },
    handleDosageFormDisplay(formData) {
      if ((this.mode === 'edit' || this.mode === 'view') && formData.dosForm) {
        const dosageFormId = formData.dosForm;
        const dosformName = formData.dosformName || '';
        const dosageExists = this.dosageFormOptions.some(item => item.id == dosageFormId);
        if (!dosageExists && dosformName) {
          this.dosageFormOptions.unshift({
            id: dosageFormId,
            dosageName: dosformName,
            label: dosformName
          });
        }
        this.form.dosageForm = dosageFormId;
      }
      return Promise.resolve();
    },
    handleUnitPriceData(formData) {
      this.form.packUnitId = formData.minUnt || null;
      this.form.minUnitId = formData.pacUnt || null;
      this.form.packConversionRate = formData.pacCnt || null;
      this.form.minConversionRate = 1;
      this.form.packRetailPrice = formData.fixMinSalePric || null;
      this.form.minRetailPrice = formData.fixPacSalePric || null;
      this.form.packMemberPrice = formData.memberMinSalePric || null;
      this.form.minMemberPrice = formData.memberPacSalePric || null;
      this.form.pacSpec = formData.pacSpec || '';
    },
    handlefoucsName() {
      this.drugName();
    },
    handleSelectFocus(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.mode === 'edit' && !this.currentQuery) {
        this.currentQuery = this.form.drugCodeName || '';
        if (this.currentQuery) {
          this.loadDefaultDrugOptions();
        }
      }
      if (!this.currentQuery && this.mode === 'add') {
        this.drugName();
      }
      this.$nextTick(() => {
        if (this.$refs.drugNameSelect) {
          this.$refs.drugNameSelect.toggleMenu();
        }
      });
    },
    handleSelectBlur(event) {
      console.log('下拉框失去焦点');
    },
    handleSelectVisibleChange(visible) {
      console.log('下拉框显示状态变化:', visible);
    },
    handleSelectClick(event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return false;
    },
    handleSelectRightClick(event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      window.addEventListener('contextmenu', this.blockContextMenu, { once: true });
      return false;
    },
    blockContextMenu(event) {
      event.preventDefault();
      event.stopPropagation();
    },
    async drugName(isLoadMore = false) {
      if (this.mode === 'view') return;
      try {
        if (!isLoadMore) {
          this.loading = true;
          this.pageNum = 1;
        } else {
          this.scrollLoading = true;
        }
        const res = await getDInfo({ productName: this.currentQuery, pageNum: this.pageNum, pageSize: this.pageSize });
        if (res.code === 200) {
          if (res.data.content && res.data.content.length > 0) {
            const newData = res.data.content.map(v => ({
              label: v.productName,
              ...v,
              _uid: Math.random().toString(36).substr(2, 9)
            }));
            if (isLoadMore) {
              this.NameOptions = [...this.NameOptions, ...newData];
            } else {
              if (this.mode === 'edit' && this.form.drugCodeId && this.form.drugCodeName) {
                const currentDrugInList = this.NameOptions.find(item => item.id === this.form.drugCodeId);
                if (!currentDrugInList) {
                  this.NameOptions = [
                    {
                      id: this.form.drugCodeId,
                      label: this.form.drugCodeName,
                      drugCode: this.form.code || '',
                      specifications: this.form.drugSpec || '',
                      dosageForm: this.form.dosformName || '',
                      approvalNumber: this.form.approvalNumber || '',
                      licensorChinese: this.form.manufacturerName || '',
                      _uid: Math.random().toString(36).substr(2, 9)
                    },
                    ...newData
                  ];
                } else {
                  this.NameOptions = newData;
                }
              } else {
                this.NameOptions = newData;
              }
            }
            this.hasMore = res.data.content.length >= this.pageSize;
            this.showNoDataPrompt = false;
          } else {
            if (!isLoadMore && this.currentQuery) {
              this.NameOptions = [];
              this.showNoDataPrompt = true;
            } else {
              this.NameOptions = [];
              this.showNoDataPrompt = false;
            }
            this.hasMore = false;
          }
        } else {
          this.$message.error(res.message || '获取药品数据失败');
          this.showNoDataPrompt = false;
        }
      } catch (error) {
        console.error('获取药品数据出错:', error);
        this.$message.error('获取药品数据失败');
        this.showNoDataPrompt = false;
      } finally {
        this.loading = false;
        this.scrollLoading = false;
      }
    },
    handleDosageFormChange(val) {
      this.form.dosForm = val;
      if (val) {
        const selectedOption = this.dosageFormOptions.find(item => item.id === val);
        if (selectedOption) {
          this.form.dosformName = selectedOption.dosageName || selectedOption.label;
        }
      } else {
        this.form.dosformName = '';
      }
    },
    getFirstLetter(str) {
      if (!str || typeof str !== 'string') return '';
      try {
        const chineseChars = str.match(/[\u4e00-\u9fa5]/g) || [];
        if (chineseChars.length === 0) return '';
        const initials = chineseChars.map(char => {
          const pinyinResult = pinyin(char, { toneType: 'none', type: 'array', multiple: false })[0] || '';
          return pinyinResult.charAt(0).toUpperCase();
        });
        return initials.join('');
      } catch (error) {
        console.error('拼音转换失败:', error);
        return '';
      }
    },
    handleFormUpdate(updatedData) {
      this.form = { ...this.form, ...updatedData };
    },
    handleFormUpdateF3(updatedData) {
      this.form = { ...this.form, ...updatedData };
    },
    handleFormUpdateF4(updatedData) {
      this.form = { ...this.form, ...updatedData };
    },
    clearPackRetailError() {
      this.retailErrors.pack = false;
    },
    clearMinRetailError() {
      this.retailErrors.min = false;
    },
    async submitForm() {
      this.$refs.topForm.validate(async (valid) => {
        if (!valid) {
          this.$message.error('请将药品档案基本信息中所需的必填信息填写完毕！');
          return;
        }

        this.retailErrors.pack = false;
        this.retailErrors.min = false;

        const packRetail = parseFloat(this.form.packRetailPrice);
        const minRetail = parseFloat(this.form.minRetailPrice);
        let hasError = false;
        if (!packRetail || packRetail <= 0) {
          this.retailErrors.pack = true;
          hasError = true;
        }
        if (!minRetail || minRetail <= 0) {
          this.retailErrors.min = true;
          hasError = true;
        }

        if (hasError) {
          this.$alert('当前单位及价格中的 零售价 为 必填项！请检查！', '系统提示', {
            confirmButtonText: '确定',
            type: 'warning'
          });
          this.loading = false;
          this.$nextTick(() => {
            const firstError = document.querySelector('.retail-error .el-input__inner');
            if (firstError) firstError.focus();
          });
          return;
        }

        try {
          this.loading = true;
          if (this.$refs.basicInfo && this.$refs.basicInfo.validateForm) {
            try {
              await this.$refs.basicInfo.validateForm();
            } catch (error) {
              console.error('基本内容验证失败:', error);
              this.$message.error('请填写完整的必填信息');
              this.loading = false;
              return;
            }
          }
          const submitData = this.buildSubmitData();
          if (!submitData.pacCnt || submitData.pacCnt <= 0) {
            this.$alert('请先设置单位关系的换算！', '系统提示', {
              confirmButtonText: '确定',
              type: 'warning'
            });
            this.loading = false;
            return;
          }
          let response;
          if (this.mode === 'add') {
            response = await addDrugInformation(submitData);
          } else {
            response = await updateDrugInformation(submitData);
          }
          if (response.code === 200) {
            this.$message.success(this.mode === 'add' ? '新增成功' : '保存成功');
            this.dialogVisible = false;
            this.$emit('refresh');
          } else {
            this.$message.error(response.message);
          }
        } catch (error) {
          console.error('保存失败:', error);
          this.$message.error('保存失败: ' + error.message);
        } finally {
          this.loading = false;
        }
      });
    },
    buildSubmitData() {
      const formData = JSON.parse(JSON.stringify(this.form));
      formData.minUnt = this.form.packUnitId || null;
      formData.pacUnt = this.form.minUnitId || null;
      const packRate = parseFloat(this.form.packConversionRate);
      const minRate = parseFloat(this.form.minConversionRate);
      if (packRate > 0 && minRate > 0) {
        formData.pacCnt = packRate / minRate;
      } else {
        formData.pacCnt = null;
      }
      formData.memberMinSalePric = this.form.packMemberPrice || null;
      formData.memberPacSalePric = this.form.minMemberPrice || null;
      formData.pacSpec = this.relationText || '';
      formData.dosForm = this.form.dosageForm || null;
      const packRetail = this.form.packRetailPrice;
      const minRetail = this.form.minRetailPrice;
      formData.fixMinSalePric = packRetail || null;
      formData.fixPacSalePric = minRetail || null;
      const hasRetail = (packRetail !== null && packRetail > 0) ||
                        (minRetail !== null && minRetail > 0);
      formData.isFixPrice = hasRetail ? 1 : 0;
      
      const manufacturerList = [];
      if (this.form.manufacturer) {
        manufacturerList.push({
          prodentpId: this.form.manufacturer,
          status: 1,
          manuLotnum: this.form.manuLotnum || '',
          periodControl: this.form.periodControl !== undefined ? this.form.periodControl : 0,
          warningDays: this.form.warningDays !== undefined ? this.form.warningDays : 0,
          expyDate: this.form.expyDate || null
        });
      }
      formData.list = manufacturerList;

      formData.state = Number(formData.state || 1);
      formData.kcId = Number(formData.kcId || 0);
      
      delete formData.packUnitId;
      delete formData.packConversionRate;
      delete formData.packRetailPrice;
      delete formData.packMemberPrice;
      delete formData.minUnitId;
      delete formData.minConversionRate;
      delete formData.minRetailPrice;
      delete formData.minMemberPrice;
      delete formData.periodControl;
      delete formData.expyDate;

      return formData;
    },
    handleClose() {
      this.resetAllValidation();
      this.resetForm();
      this.dialogVisible = false;
      this.$emit('close');
    },
    resetAllValidation() {
      if (this.$refs.topForm) {
        this.$refs.topForm.clearValidate();
      }
      this.resetChildValidation();
    },
    resetChildValidation() {
      if (this.$refs.basicInfo && this.$refs.basicInfo.resetAllValidation) {
        this.$refs.basicInfo.resetAllValidation();
      }
      if (this.$refs.kzInfo && this.$refs.kzInfo.resetAllValidation) {
        this.$refs.kzInfo.resetAllValidation();
      }
      if (this.$refs.useInfo && this.$refs.useInfo.resetAllValidation) {
        this.$refs.useInfo.resetAllValidation();
      }
    },
    resetFormValidation() {
      if (this.$refs.topForm) {
        this.$nextTick(() => {
          this.$refs.topForm.clearValidate();
        });
      }
    },
    resetForm() {
      this.form = {
        state: 1,
        kcId: 0,
        drugCodeId: '',
        dosageForm: '',
        drugType: 1,
        drugName: '',
        drugCodeName: '',
        code: '',
        drugSpec: '',
        dosForm: '',
        pyCode: '',
        mrsId: '',
        expensiveType: 1,
        packUnitId: null,
        packConversionRate: null,
        packRetailPrice: null,
        packMemberPrice: null,
        minUnitId: null,
        minConversionRate: 1,
        minRetailPrice: null,
        minMemberPrice: null,
        manufacturer: null,
        manuLotnum: '',
        periodControl: 0,
        expyDate: null,
        warningDays: 0,
        approvalNumber: '',
      };
      this.NameOptions = [];
      this.currentQuery = '';
      this.pageNum = 1;
      this.hasMore = true;
      this.scrollLoading = false;
      this.showNoDataPrompt = false;
      this.pendingPreFillData = null;
    },
  }
};
</script>

<style lang="less" scoped>
::v-deep .retail-error {
  .el-input__inner {
    border-color: #F56C6C !important;
    box-shadow: 0 0 6px rgba(245, 108, 108, 0.3);
    &:focus {
      border-color: #F56C6C;
    }
  }
}
.add-drug-container {
  ::v-deep * {
    box-sizing: border-box;
  }
  ::v-deep .el-dialog {
    border-radius: 8px !important;
    overflow: hidden;
    height: 80vh;
    display: flex;
    flex-direction: column;
    .el-dialog__header {
      padding: 12px 20px 12px 20px !important;
      background: linear-gradient(135deg, #00557f 0%, #ebfaff 100%);
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      flex-shrink: 0;
      position: relative;
      .dialog-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        .dialog-header-title {
          color: #fff;
          font-size: 16px;
          font-weight: bold;
        }
        .header-buttons {
          .close-button {
            color: #fff;
            padding: 0;
            width: 20px;
            height: 20px;
            font-size: 16px;
          }
        }
      }
    }
    .el-dialog__body {
      padding: 0 !important;
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }
    .dialog-footer {
      flex-shrink: 0;
    }
  }
  .dialog-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    .top-section {
      flex: 0 0 60%;
      display: flex;
      flex-direction: column;
      min-height: 0;
      overflow: hidden;
      .form-top {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
        overflow: hidden;
        .el-form {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          min-height: 0;
          .fixed-form-row {
            margin-bottom: 12px;
            padding: 0;
            display: flex;
            align-items: stretch;
            border: 1px solid #dcdfe6;
            border-radius: 4px;
            overflow: hidden;
            flex-shrink: 0;
          }
          .el-col {
            padding: 0;
            border-right: 1px solid #dcdfe6;
            &:first-child {
              border-left: 1px solid #dcdfe6;
            }
            &:last-child {
              border-right: 1px solid #dcdfe6;
            }
          }
          .el-form-item {
            margin-bottom: 0;
            display: flex;
            align-items: stretch;
            width: 100%;
            height: 100%;
            &.form-item-with-border {
              display: flex;
              align-items: stretch;
              height: 100%;
              ::v-deep .el-form-item__label {
                background-color: #f5f7fa;
                border: none;
                padding: 0 8px;
                line-height: 32px;
                height: 100%;
                font-weight: bold;
                color: #00557f;
                width: 100px;
                text-align: right;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                font-size: 12px;
                border-right: 1px solid #dcdfe6;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              ::v-deep .el-form-item__content {
                border: none;
                line-height: 32px;
                height: 100%;
                flex: 1;
                margin-left: 0 !important;
                display: flex;
                align-items: stretch;
                .el-select, .el-input {
                  width: 100%;
                  height: 100%;
                  .el-input__inner {
                    border: none;
                    height: 100%;
                    line-height: 30px;
                    padding: 0 8px;
                    font-size: 12px;
                    color: #606266;
                    &:focus {
                      outline: none;
                      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
                    }
                  }
                  .el-input__suffix {
                    display: flex;
                    align-items: center;
                    right: 5px;
                  }
                }
              }
            }
          }
          .tab-content-fixed-height {
            flex: 1;
            display: flex;
            flex-direction: column;
            min-height: 0;
            overflow: hidden;
            position: relative;
            .form-tabs {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              display: flex;
              flex-direction: column;
              ::v-deep .el-tabs__header {
                margin: 0 0 8px 0;
                flex-shrink: 0;
                background-color: #f5f7fa;
                border-radius: 4px;
                padding: 6px 12px;
                .el-tabs__nav-wrap {
                  &::after {
                    display: none;
                  }
                }
                .el-tabs__item {
                  font-weight: bold;
                  color: #00557f;
                  font-size: 13px;
                  padding: 0 16px;
                  height: 32px;
                  line-height: 32px;
                  &.is-active {
                    color: #00557f;
                    background-color: #fff;
                    border-radius: 4px;
                    border: 1px solid #e0e0e0;
                    border-bottom: none;
                  }
                  &:hover {
                    color: #00557f;
                  }
                }
              }
              ::v-deep .el-tabs__content {
                flex: 1;
                display: flex;
                flex-direction: column;
                min-height: 0;
                overflow: hidden;
                position: relative;
                .basic-info, .kz-info, .use-info {
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  display: flex;
                  flex-direction: column;
                  overflow: hidden;
                  .basic-info-container {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    min-height: 0;
                    overflow-y: auto;
                    overflow-x: hidden;
                    border: 1px solid #e8e8e8;
                    border-radius: 4px;
                    padding: 12px;
                    box-sizing: border-box;
                    &::-webkit-scrollbar {
                      width: 8px;
                      height: 8px;
                    }
                    &::-webkit-scrollbar-track {
                      background: #f5f5f5;
                      border-radius: 4px;
                    }
                    &::-webkit-scrollbar-thumb {
                      background: #c1c1c1;
                      border-radius: 4px;
                      &:hover {
                        background: #a8a8a8;
                      }
                    }
                    scrollbar-width: thin;
                    scrollbar-color: #c1c1c1 #f5f5f5;
                  }
                }
              }
            }
          }
        }
      }
    }
    .bottom-section {
      flex: 0 0 40%;
      display: flex;
      flex-direction: column;
      min-height: 0;
      overflow: hidden;
      padding: 0 12px 12px 12px;
      .section-header {
        padding: 10px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #f5f7fa;
        flex-shrink: 0;
        .section-title {
          display: flex;
          align-items: center;
          span {
            font-weight: bold;
            color: #00557f;
            font-size: 14px;
            margin-right: 12px;
          }
        }
      }
      .unit-price-layout {
        flex: 1;
        display: flex;
        min-height: 0;
        gap: 0;
        .unit-price-table-wrapper {
          flex: 0 0 70%;
          border: 1px solid #e8e8e8;
          border-radius: 4px 0 0 4px;
          overflow: hidden;
          background: #fff;
          ::v-deep .el-table {
            height: 100%;
            font-size: 12px;
            .el-table__header-wrapper, .el-table__body-wrapper {
              font-size: 12px;
            }
            th, td {
              padding: 4px 6px;
              font-size: 12px;
            }
            .cell {
              padding: 0 4px;
            }
            .el-select {
              width: 100%;
            }
            .el-input {
              width: 100%;
            }
            .el-input__inner {
              height: 28px;
              line-height: 28px;
              padding: 0 6px;
            }
          }
        }
        .unit-relation-right {
          flex: 1;
          padding: 12px 8px;
          background-color: #fafafa;
          border: 1px solid #e8e8e8;
          border-left: none;
          border-radius: 0 4px 4px 0;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #333;
          .relation-label {
            font-weight: bold;
            color: #00557f;
            margin-right: 4px;
          }
          .relation-value {
            color: #409EFF;
            font-weight: bold;
          }
          .relation-placeholder {
            color: #909399;
            font-style: italic;
          }
        }
      }
    }
  }
  .dialog-footer {
    padding: 12px;
    border-top: 1px solid #ebeef5;
    text-align: right;
    .el-button {
      font-size: 12px;
    }
  }
}
</style>